import { __extends } from "tslib";
import React from "react";
import { ERROR_TEXT } from "../constants";

var ErrorBoundary =
/** @class */
function (_super) {
  __extends(ErrorBoundary, _super);

  function ErrorBoundary() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      error: null
    };
    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function (err) {
    return {
      error: err
    };
  };

  ErrorBoundary.prototype.componentDidCatch = function (error, info) {
    console.error(error);
    console.error(info);
  };

  ErrorBoundary.prototype.render = function () {
    if (!!this.state.error) {
      return React.createElement("section", {
        className: "dc__error"
      }, React.createElement("p", null, ERROR_TEXT));
    }

    return this.props.children;
  };

  return ErrorBoundary;
}(React.Component);

export { ErrorBoundary };